import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const KlarnaBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.KLARNA}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.KLARNA)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.KLARNA)} alt="klarna" />
    </Box>
  );
};
